module.exports = __webpack_public_path__ + "media/images/landing/second_2x/photo22-a3fc1f2ed32f081862df0d13cd37af9f.jpg";